import { FC } from 'react';
import { Button } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

import { TrainingGroup } from '../CourseEnrollment.const';
import css from '../CourseEnrollment.module.css';

interface Props {
  contractNumber: string;
  group: TrainingGroup | undefined;
  email: string;
  onMyCourses: () => void;
  onCoursesList: () => void;
}

const DoneStep: FC<Props> = ({
  contractNumber,
  group,
  email,
  onMyCourses,
  onCoursesList,
}) => (
  <div className={css.DonePage}>
    <span className={css.DoneIcon}>
      <CheckCircleFilled />
    </span>
    <h2 className={css.DoneTitle}>Договор оформлен</h2>
    <p className={css.DoneText}>
      Договор {contractNumber} успешно создан. Группа: {group?.name} (
      {group?.startDate} — {group?.endDate}). Чек и реквизиты для оплаты
      отправлены на {email || 'указанный e-mail'}.
    </p>
    <div className={css.PrimaryActions} style={{ marginBottom: 0 }}>
      <Button className={css.ViewContractBtn} onClick={onMyCourses}>
        В мои курсы
      </Button>
      <Button className={css.PayBtn} onClick={onCoursesList}>
        К списку курсов
      </Button>
    </div>
  </div>
);

export default DoneStep;
